/*
* Consultsummary is the provides the consutlist accordion header contents
* starred, date, consult keywords, examlabels
* */
(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consultkeywords', {
      restrict: 'E',
      bindings: {
        keywords: '=',
        parentsave: '&'
      },
      templateUrl: 'vcconsult/consultkeywords-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', function ($log) {
        let vm = this;
        vm.updateColor = updateColor;
        vm.addKeyword = addKeyword;
        vm.editKeyword = editKeyword;
        vm.removeKeyword = removeKeyword;

        vm.$onInit = function () {
          if (angular.isUndefined(vm.customlabels)) {
            vm.customlabels = {
              primary: 'Neu',
              info: 'Fremdinformation',
              danger: 'Gefahr',
              warning: 'Warnung',
              success: 'Erfolg'
            };
          }
        };

        function editKeyword(kw) {
          $log.debug('edited kw: ', kw);
          save();
        }

        function updateColor(kw, color) {
          kw.col = color;
          save();
        }

        function removeKeyword(kw) {
          kw.active = false;
          save();
        }

        function addKeyword() {
          if (angular.isDefined(vm.newkeyword) && vm.newkeyword.length > 0) {
            let kw = {};
            kw.col = 'primary';
            kw.key = vm.newkeyword;

            if (!angular.isArray(vm.keywords)) {
              vm.keywords = [];
            }
            vm.keywords.push(kw);

            vm.newkeyword = '';
            save();
          }
        }

        function save() {
          $log.debug('***: diagnoseedit calling parentsave: ', vm.parentsave);
          vm.parentsave();
        }

        vm.$onChanges = function (changes) {
          /*                  if (angular.isDefined(changes.starred) && angular.isDefined(changes.starred.currentValue)
                                && changes.starred.currentValue !== '') {
                              vm.starred = changes.starred.currentValue === 'true';
                            }

                            if (angular.isDefined(changes.keywords) && angular.isDefined(changes.keywords.currentValue)
                                && angular.isArray(changes.keywords.currentValue)) {
                              vm.keywords = changes.keywords.currentValue;
                            }*/
          if (angular.isDefined(changes.parentsave) && angular.isDefined(changes.parentsave.currentValue)
            && angular.isFunction(changes.parentsave.currentValue)) {
            vm.parentsave = changes.parentsave.currentValue;
          }
        };


      }]
    });
// klammerfriedhof
}());
